import React from 'react';

const ButtonOutline = ({ children, size = 'md', onClick = () => {}, disabled = false }) => (
    <button
        className={`appButton__outline ${size}`}
        type="button"
        disabled={disabled}
        onClick={onClick}>
        {children}
    </button>
);

export default ButtonOutline;
